module.exports = __webpack_public_path__ + "img/webeye.3b3e8a2.png";